<script>
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import Select from "primevue/select";
import FormLabel from "@/components/FormLabel.vue";
import { SUBSCRIPTION_PLANS } 
  from "@/dashboard/organization/Organization";
export default {
  name: "SubscriptionExtensionDelete",
  components: { FormLabel, Button, Dialog, Select },

  emits: ["close", "submit"],

  props: {
    visible: { type: Boolean, required: true },
    member: { type: [Object, null], required: true },
    categories: { type: Array, required: true }
  },

  computed: {
    shown() {
      return this.visible;
    },

    orgMember() {
      return this.member;
    },
subscriptionOptions() {
  return [...SUBSCRIPTION_PLANS];
},
 filteredCategories() {
 let extensions = this.member?.extra?.subscriptionExtensions;

  // Ensure it's always an array
  if (!Array.isArray(extensions)) {
    extensions = extensions ? Object.values(extensions) : [];
  }
/*
  const validExtensions = extensions
    .filter(ext => ext.valid === "Y");

  const extendedIds = validExtensions
    .map(ext => Number(ext.categoryId));
*/
  return this.categories.filter(cat =>
    extensions.includes(Number(cat.value))
  );
}},

  data() {
    return {
      selectedCategory: null,
      existingSubscription: null,
       selectedSubscription: null  
    };
  },

  watch: {
    member: {
      immediate: true,
      handler() {
        this.selectedCategory = null;
        this.existingSubscription = null;
      }
    },

   selectedCategory(newVal) {
  if (!newVal || !this.member || !this.member.subscriptionsMap) {
    this.existingSubscription = null;
    this.selectedSubscription = null;
    return;
  }

  const selectedCat = this.filteredCategories.find(
    cat => cat.value === newVal
  );

  if (!selectedCat) return;

  const subscriptionEntry = Object.entries(
    this.member.subscriptionsMap
  ).find(([key]) =>
    key.trim().toLowerCase() === selectedCat.label.trim().toLowerCase()
  );

  this.existingSubscription = subscriptionEntry
    ? subscriptionEntry[1]
    : null;

  this.selectedSubscription = subscriptionEntry
    ? subscriptionEntry[1].subscription?.toUpperCase()
    : null;
}},

  methods: {
   submitDelete() {

  if (!this.selectedCategory) {
    this.$root.showAlert(
      "warn",
      "Subscription Extension Deletion",
      "Category is required"
    );
    return;
  }

      const payload = this.$root.addInstitutionId({
        memberId: this.orgMember.id,
        categoryId: this.selectedCategory,
        subscription: this.selectedSubscription
      }, false, true);

      const TITLE = "Subscription Extension Deletion";

      this.$api.post("/institution/subscription/extend/delete", payload)
        .then(res => {
          this.$root.showAlert("success", TITLE, res.message);
          this.$emit("submit");
        })
        .catch(err => {
          const msg =
            err?.response?.data?.message || "Oops, Something Went Wrong";

          this.$root.showAlert("error", TITLE, msg);
        });
},
    formatDate(date) {
      if (!date) return "-";
      return new Date(date).toLocaleDateString();
    }
  }
};
</script>
<template>
  <Dialog
  :visible="shown"
  class="w-md-50 w-100"
  :draggable="false"
  :modal="true"
  :close-on-escape="false"
  :header="orgMember ? (orgMember.firstName + ' ' + orgMember.lastName).toUpperCase() : ''"
  :closable="false"
>
  <div class="row mt-4">

    <!-- Category -->
    <div class="col-12 mb-3">
      <FormLabel label-text="Category" required />
      <Select
        :options="filteredCategories"
        v-model="selectedCategory"
        optionLabel="label"
        optionValue="value"
        placeholder="Select Category"
        class="w-100"
      />
    </div>

    <!-- Existing Subscription Text -->
<div v-if="existingSubscription" class="col-12 mb-2">
  <small class="text-muted fw-bold">
    Existing Subscription :
  </small>

  <div class="fw-bold text-primary">
    {{ existingSubscription.subscription }}
  </div>

  <div class="text-muted small">
    <div>
      Start Date :
      {{ formatDate(existingSubscription.start) }}
    </div>
    <div>
      End Date :
      {{ formatDate(existingSubscription.deadline) }}
    </div>
  </div>
</div>
  </div>

  <template #footer>
    <div class="row w-100 px-0 mx-0">
      <div class="col-6 ps-0">
        <Button
          label="Cancel"
          severity="secondary"
          @click="$emit('close')"
          class="w-100"
          icon="pi pi-times"
        />
      </div>

      <div class="col-6 pe-0">
        <Button
          label="Delete Extension"
          severity="danger"
          @click="submitDelete"
          class="w-100"
          icon="pi pi-trash"
        />
      </div>
    </div>
  </template>
</Dialog>
</template>

<style scoped>
</style>